var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5576 1.66675H13.9742C12.1576 1.66675 11.1992 2.62508 11.1992 4.44175V6.02508C11.1992 7.84175 12.1576 8.80008 13.9742 8.80008H15.5576C17.3742 8.80008 18.3326 7.84175 18.3326 6.02508V4.44175C18.3326 2.62508 17.3742 1.66675 15.5576 1.66675Z",
    fill: "#040F1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03464 11.1917H4.4513C2.6263 11.1917 1.66797 12.15 1.66797 13.9667V15.55C1.66797 17.375 2.6263 18.3333 4.44297 18.3333H6.0263C7.84297 18.3333 8.8013 17.375 8.8013 15.5583V13.975C8.80964 12.15 7.8513 11.1917 6.03464 11.1917Z",
    fill: "#040F1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24297 8.81675C7.21739 8.81675 8.81797 7.21617 8.81797 5.24175C8.81797 3.26733 7.21739 1.66675 5.24297 1.66675C3.26855 1.66675 1.66797 3.26733 1.66797 5.24175C1.66797 7.21617 3.26855 8.81675 5.24297 8.81675Z",
    fill: "#040F1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7586 18.3333C16.733 18.3333 18.3336 16.7328 18.3336 14.7583C18.3336 12.7839 16.733 11.1833 14.7586 11.1833C12.7842 11.1833 11.1836 12.7839 11.1836 14.7583C11.1836 16.7328 12.7842 18.3333 14.7586 18.3333Z",
    fill: "#040F1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoDashboardActive);
export default __webpack_public_path__ + "static/media/trvto_dashboardActive.49eb9bde421fca9becc9d471085bd892.svg";
export { ForwardRef as ReactComponent };